import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { ImageElement } from "./ImageElement";
import { StageController } from "../../StageController";
import { BaseElement } from "./BaseElement";
import { StyleManager } from "../../Managers/StyleManager";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../../Utils/FrameTimer";
import { BGParticleStyle } from "../Styles/BGParticleStyle";

// TODO add comments
/**
 * BGParticleElement class is class which creates particles of images on full screen that moves in diferent ways, speed, scale,....
 * Can be defined only with BGParticleStyle (See BGParticleStyle class).
 * Example 1:
 *   <BGParticleElement Class="BGParticleElement" Style="BGParticleStyle" />
 *
 * @class SwitchElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class BGParticleElement extends BaseElement {
    // handle definition for particles
    private _style: BGParticleStyle;
    private _styleName: string;
    //  holds particles in pool and reused them
    private _pool: Array<ImageElement>;
    // timer for add particles
    private _timer: FrameTimerEventEmitter;

    private _stopping: boolean;
    private _stop: boolean;
    private _emitOnce: boolean;
    private _startType: string;

    private _blendMode: number;

    private circles: Array<any> = [];
    private circlesData: Array<any> = [];
    private lines: PIXI.Graphics;

    private connectionZoneWidth: Array<any> = [];
    private connectionZoneHeight: Array<any> = [];

    private counts: number;

    constructor() {
        super();

        this._pool = [];

        this._timer = CreateFrameTimer("bgTimer");
        this._timer.on(FrameTimerEvents.Complete, this.startUpdate.bind(this));

        this._stopping = false;
        this._stop = true;
        this._emitOnce = false;
        this._startType = "";
        this.visible = false;
        this.counts = 0;
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (node.hasAttribute(BGParticleElementAttributes.BLEND_MODE)) {
            this._blendMode = parseInt(node.getAttribute(BGParticleElementAttributes.BLEND_MODE));
        }

        if (node.hasAttribute(BGParticleElementAttributes.STYLE)) {
            this._style = <BGParticleStyle>StyleManager.Styles[node.getAttribute(BGParticleElementAttributes.STYLE)];
            this._styleName = this._style.name;
            this.visible = true;

            this.connectionZoneHeight = this._style.connectionZoneHeight;
            this.connectionZoneWidth = this._style.connectionZoneWidth;

            this.createParticles();
        }
    }

    updateByNode(node: Element): void {
        super.updateByNode(node);
    }

    private createParticles(): void {
        let startCount = this._style.count;
        let imageElement: any;

        this.counts = this._style.counts[this._style.connected - 1];

        for (let i = 0; i < startCount; i++) {
            let speedX: number = 0;
            let speedY: number = 0;
            let scale: number = 1;
            let randomX = Math.random() * StageController.Width;
            let randomY = Math.random() * StageController.Height;

            for (let j = 0; j < this._style.images.length; j++) {
                if (i < this._style.counts[j]) {
                    imageElement = new ImageElement(StageController.getTextureByResourceId(this._style.images[j]));
                    speedX =
                        Math.random() * (this._style.speedX[j][1] - this._style.speedX[j][0]) +
                        this._style.speedX[j][0];
                    speedY =
                        Math.random() * (this._style.speedY[j][1] - this._style.speedY[j][0]) +
                        this._style.speedY[j][0];
                    scale =
                        Math.random() * (this._style.scale[j][1] - this._style.scale[j][0]) + this._style.scale[j][0];
                    break;
                }
            }

            imageElement.position.x = randomX;
            imageElement.position.y = randomY;
            imageElement.pivot.x = imageElement.width / 2;
            imageElement.pivot.y = imageElement.height / 2;
            imageElement.scale.x = scale;
            imageElement.scale.y = scale;

            if (Math.round(Math.random()) == 0) {
                speedX = -speedX;
            }

            if (Math.round(Math.random()) == 0) {
                speedY = -speedY;
            }

            this.circles.push(imageElement);
            this.addChild(imageElement);
            this.circlesData.push([speedX, speedY]);
        }

        // for(let i=0; i< this.circles.length;i++){
        //     let pointsS: Array<any>= [];
        //     let counter = 0
        //
        //     for (let j = i; j < this.circles.length;j++) {
        //         if(i < this.counts && j < this.counts){
        //
        //             let distance = Math.sqrt(Math.pow(this.circles[j].x - this.circles[i].x, 2) + Math.pow(this.circles[j].y - this.circles[i].y, 2));
        //             let opacity = 1 - distance / this._style.radius;
        //             if (opacity > 0) {
        //                 if(opacity > this._style.lineAlpha) {opacity = this._style.lineAlpha}
        //                 if(counter<3){
        //                     pointsS.push(this.circles[j])
        //                 }
        //                 counter++;
        //             }
        //         }
        //     }
        //     // if(pointsS.length == 3)
        //         this.conectedPoints.push(pointsS)
        // }

        this.lines = new PIXI.Graphics();
        this.addChildAt(this.lines, 0);
        this.startUpdate();
    }

    startUpdate(): void {
        let _this = this;
        _this.updateU();
        this._timer.start(2);
    }

    updateU(): void {
        this.lines.clear();

        for (let i = 0; i < this.circles.length; i++) {
            this.circles[i].position.x += this.circlesData[i][0];
            this.circles[i].position.y += this.circlesData[i][1];

            if (this.circles[i].position.x > 1920) {
                this.circlesData[i][0] *= -1;
                this.circles[i].position.x = 1920;
            } else if (this.circles[i].position.x < 0) {
                this.circlesData[i][0] *= -1;
                this.circles[i].position.x = 0;
            }

            if (this.circles[i].position.y > 1080) {
                this.circlesData[i][1] *= -1;
                this.circles[i].position.y = 1080;
            } else if (this.circles[i].position.y < 0) {
                this.circlesData[i][1] *= -1;
                this.circles[i].position.y = 0;
            }

            let inZone = false;
            for (let k = 0; k < this.connectionZoneHeight.length; k++) {
                if (
                    this.circles[i].position.y >= this.connectionZoneHeight[k][0] &&
                    this.circles[i].position.y <= this.connectionZoneHeight[k][1] &&
                    this.circles[i].position.x >= this.connectionZoneWidth[k][0] &&
                    this.circles[i].position.x <= this.connectionZoneWidth[k][1]
                ) {
                    inZone = true;
                }
            }

            if (inZone) {
                if (this.circles[i].alpha < 1) {
                    this.circles[i].alpha += 0.0125;
                }

                for (let j = i; j < this.circles.length; j++) {
                    if (i < this.counts && j < this.counts) {
                        let distance = Math.sqrt(
                            Math.pow(this.circles[j].x - this.circles[i].x, 2) +
                                Math.pow(this.circles[j].y - this.circles[i].y, 2),
                        );
                        let opacity = 1 - distance / this._style.radius;

                        if (opacity > 0) {
                            if (opacity > this._style.lineAlpha) {
                                opacity = this._style.lineAlpha;
                            }
                            this.lines
                                .lineStyle(this._style.lineWidth, this._style.lineColor, opacity)
                                .moveTo(this.circles[i].x, this.circles[i].y)
                                .lineTo(this.circles[j].x, this.circles[j].y);
                        }
                    }
                }
            } else {
                if (this.circles[i].alpha > 0.3) {
                    this.circles[i].alpha -= 0.0125;
                }
            }
        }
    }

    public degrees2radians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return BGParticleElement
     */
    clone(): BGParticleElement {
        let element: BGParticleElement = new BGParticleElement();
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        let node: Element = document.createElement("particle");
        node.setAttribute("Style2", this._styleName);
        element.create(node);
        element._markAsCloned(); // must be called last before return!
        return element;
    }
}

export const BGParticleElementAttributes = {
    /**
     * Blend mode for animation.
     * Bleding modes:
     *   0 = NORMAL;
     *   1 = ADD;
     *   2 = MULTIPLY;
     *   3 = SCREEN;
     *   4 = OVERLAY;
     *   5 = DARKEN;
     *   6 = LIGHTEN;
     *   7 = COLOR_DODGE;
     *   8 = COLOR_BURN;
     *   9 = HARD_LIGHT;
     *   10 = SOFT_LIGHT;
     *   11 = DIFFERENCE;
     *   12 = EXCLUSION;
     *   13 = HUE;
     *   14 = SATURATION;
     *   15 = COLOR;
     *   16 = LUMINOSITY;
     * @property BlendMode
     * @default null
     */
    BLEND_MODE: "BlendMode",
    SPEED_X: "SpeedX",
    SPEED_Y: "SpeedY",
    EMIT_ONCE: "EmitOnce",
    START_TYPE: "StartType",
    // Tweens used in BaseElementParticle
    ALPHA: "Alpha",

    SCALE: "Scale",

    /**
     * Style define animation. You can use one style on more than one place.
     * Style for BGParticleElement has to be instance of ParticleStyle.
     * @property Style
     * @type string
     * @default null
     */
    STYLE: "Style",
    START: "Start",
    STOPPING: "Stopping",
    STOP: "Stop",
    /**
     * Tint of animation. Hex color which colorize movie clip.
     * @property Tint
     * @type string
     * @default null
     */
    TINT: "Tint",
    ATTR_COUNT: "Count",
    ATTR_COUNTS: "Counts",
    ATTR_IMAGES: "Images",
    ATTR_FROM_FRAME: "FromFrame",
    ATTR_X: "X",
    ATTR_Y: "Y",
    RADIUS: "Radius",
    CONNECTED: "Connected",
    CONNECTION_ZONE_HEIGHT: "ConnectionZoneHeight",
    CONNECTION_ZONE_WIDTH: "ConnectionZoneWidth",
    LINE_COLOR: "LineColor",
    LINE_WIDTH: "LineWidth",
    LINE_ALPHA: "LineAlpha",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/BGParticleElement.ts
 **/